

export const mailTo = () => {
  window.location.href = 'mailto:contact@launchcraft.co.uk'; 
};